module.exports = __webpack_public_path__ + "static/Xorn-f339e4ff3b8dc1aa5d5abbabb5ec57a5.jpg";